import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { penStudyAnalysesActions } from 'features/penStudyAnalyses';

const usePenStudyAnalyses = () => {
  const dispatch = useDispatch();
  const getPenStudyAnalyses = useCallback(({ offset }) => dispatch(penStudyAnalysesActions.getPenStudyAnalyses({ offset })), [dispatch]);
  const getPenStudyAnalysis = useCallback(({ id, cable }) => dispatch(penStudyAnalysesActions.getPenStudyAnalysis({ id, cable })), [dispatch]);
  const clearLocalPenStudyAnalyses = useCallback(() => dispatch(penStudyAnalysesActions.clearLocalPenStudyAnalyses()), [dispatch]);
  const clearLocalActivePenStudyAnalysis = useCallback(() => dispatch(penStudyAnalysesActions.clearLocalActivePenStudyAnalysis()), [dispatch]);

  return {
    getPenStudyAnalyses,
    getPenStudyAnalysis,
    clearLocalPenStudyAnalyses,
    clearLocalActivePenStudyAnalysis
  };
};

export default usePenStudyAnalyses;